// extracted by mini-css-extract-plugin
export var alertMsg__crossBtn = "AlertPopUp-module--alertMsg__crossBtn--wJmP-";
export var alertMsg__img = "AlertPopUp-module--alertMsg__img--FgoEj";
export var alertMsg__modalBody = "AlertPopUp-module--alertMsg__modalBody--QHCou";
export var alertMsg__para = "AlertPopUp-module--alertMsg__para--hoD0P";